import { BrandDeleteModalProps } from "./types";
import { loadingComplete, showLoading } from "utils/loader";
import { net } from "utils/net";

import { ModalComponent } from "components";
import { Box, Stack, Text } from "@mantine/core";

import { useAuth } from "providers/auth";
import { useState } from "react";

export function BrandDeleteModal(props: BrandDeleteModalProps) {
  const { context, id, innerProps } = props;
  const { brand, onSubmit } = innerProps;
  const { accessToken } = useAuth();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!accessToken) return;

    try {
      showLoading("brand.delete");
      setIsLoading(true);
      const relativeUrl = `/brands/${brand.id}`;
      const netInstance = net(accessToken);
      await netInstance.delete(relativeUrl);
      if (onSubmit) await onSubmit();

      context.closeModal(id);
      loadingComplete("brand.delete", false);
    } catch (err) {
      loadingComplete("brand.delete", true);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Stack>
        <Box>
          <Text>
            Your <strong>{brand.name}</strong> brand will be deleted. Please
            note that you can not recover the deleted brand.
          </Text>
        </Box>
        <ModalComponent.ActionButtons
          context={context}
          id={id}
          submit={{ label: "Delete", disabled: isLoading }}
        />
      </Stack>
    </form>
  );
}
